import { PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EdiEligibilityCheckPermissionSet {
  View = 'edi_eligibility_check_view',
  Write = 'edi_eligibility_check_write',
}

export const EdiEligibilityCheckPermissions = {
  [EdiEligibilityCheckPermissionSet.View]: [PermissionType.GET_ANY_EDI_ELIGIBILITY_CHECK],
  [EdiEligibilityCheckPermissionSet.Write]: [PermissionType.WRITE_ANY_EDI_ELIGIBILITY_CHECK],
}

export const ediEligibilityCheckPermissionSetGrouping = {
  key: PermissionSetGroupingKey.EdiEligibilityCheck,
  active: EdiEligibilityCheckPermissions,
  unAssignablePermissionSets: [],
}
